<template>
  <div>
    
    <div v-if="showCookieConsent" class="cookie-consent">
      <div class="cookie-content">
        <p>
          This website uses cookies to improve your experience.
          <router-link to="/privacy-policy">Read more</router-link>.
          By clicking "Accept all", you consent to the use of all cookies.
          You may also visit
          <a href="#" @click.prevent="showCookieSettings = true">Cookie settings</a> and make individual choices.
        </p>
        <button @click="acceptCookies">ACCEPT ALL</button>
      </div>
    </div>

    
    <div v-if="showCookieSettings" class="backdrop"></div>

    
    <div v-if="showCookieSettings" class="cookie-settings-modal" role="dialog" aria-modal="true" aria-labelledby="cookieSettingsTitle">
      <div class="modal-content">
        <h5 id="cookieSettingsTitle">Cookie Settings</h5>
        <button @click="closeSettings" class="close-btn">×</button>

        <p>
          This website uses various types of cookies. Some cookies are essential for functionality,
          while others are used for analytics. You can choose to enable or disable them.
        </p>

        <div>
          <label>
            <input type="checkbox" v-model="cookies.necessary" disabled>
            Necessary Cookies
          </label>
          <label>
            <input type="checkbox" v-model="cookies.analytics">
            Analytics Cookies
          </label>
        </div>

        <button @click="saveSettings">Save Settings</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCookieConsent: !this.hasConsented(),
      showCookieSettings: false,
      cookies: {
        necessary: true,
        analytics: false,
      }
    };
  },
  methods: {
    acceptCookies() {
      this.setCookieConsent(true);
      this.showCookieConsent = false;
    },
    saveSettings() {
      this.setCookieConsent(true);
      this.showCookieConsent = false;
      this.showCookieSettings = false;
      
      localStorage.setItem("analyticsCookies", this.cookies.analytics);
    },
    closeSettings() {
      this.showCookieSettings = false;
    },
    setCookieConsent(consent) {
      localStorage.setItem("cookieConsent", consent);
    },
    hasConsented() {
      return localStorage.getItem("cookieConsent") === "true";
    }
  }
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #1e3163;
  color: white;
  padding: 16px;
  font-size: 14px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.cookie-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.cookie-content p {
  margin: 0;
  padding-right: 1rem;
  flex: 1;
  font-size: 17px;
  font-family: "Poppins", sans-serif;
  font-weight: 200;
}

.cookie-content a {
  color: #5ba6ff;
  text-decoration: underline;
  cursor: pointer;
}

.cookie-content button {
  background-color: #3478f6;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.3s ease;
}

.cookie-content button:hover {
  background-color: #255edb;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.cookie-settings-modal {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #ccc;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  z-index: 1001;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.cookie-settings-modal h5 {
  margin-top: 0;
  font-size: 18px;
}

.cookie-settings-modal label {
  display: block;
  margin: 12px 0;
}

.cookie-settings-modal input[type="checkbox"] {
  margin-right: 8px;
}

.cookie-settings-modal button {
  background-color: #3b71f3;
  color: white;
  padding: 10px 20px;
  border: none;
  margin-top: 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
}

.cookie-settings-modal button:hover {
  background-color: #2958d6;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}
</style>
